export const iconFontAwesomeEnergyPlugCircleCheck = (
	<i className="fa-solid fa-plug-circle-check"></i>
);
